import React, { useEffect, useRef, useState } from "react";
import "../my component/style.css";

export default function Section2() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            entry.target.classList.add("fade-in-visible");
          }
        });
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const skills = [
    { name: "React", level: 40, color: "#61DAFB", icon: "⚛️" },
    { name: "JavaScript", level: 60, color: "#F7DF1E", icon: "🟡" },
    { name: "C ", level: 55, color: "#3178C6", icon: "🔷" },
    { name: "Node.js", level: 65, color: "#339933", icon: "🟢" },
    { name: "Python", level: 70, color: "#3776AB", icon: "🐍" },
    { name: "CSS/SCSS", level: 88, color: "#1572B6", icon: "🎨" },
  ];

  return (
    <section id="about" className="section2" ref={sectionRef}>
      <div className="section2-container">
        {/* About Section */}
        <div className={`about-content ${isVisible ? "fade-in-visible" : ""}`}>
          <div className="section-badge">About</div>
          <h2 className="section2-title">About Me</h2>
          <p className="about-description">
            I'm a passionate full-stack developer with expertise in modern web
            technologies. I love creating beautiful, functional applications
            that solve real-world problems. With a strong foundation in both
            frontend and backend development, I bring ideas to life through
            clean code and innovative solutions.
          </p>

          <div className="stats-grid">
            <div className="stat-item">
              <div className="stat-number">35+</div>
              <p className="stat-label">Projects Completed</p>
            </div>
            <div className="stat-item">
              <div className="stat-number">1+</div>
              <p className="stat-label">Years Experience</p>
            </div>
            <div className="stat-item">
              <div className="stat-number">0+</div>
              <p className="stat-label">Happy Clients</p>
            </div>
          </div>
        </div>

        {/* Skills Section */}
        <div className={`skills-section ${isVisible ? "fade-in-visible" : ""}`}>
          <h2 className="section2-title">Technical Skills</h2>
          <div className="skills-grid">
            {skills.map((skill, index) => (
              <div
                key={index}
                className="skill-card"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="skill-header">
                  <div className="skill-info">
                    <span className="skill-icon">{skill.icon}</span>
                    <span className="skill-name">{skill.name}</span>
                  </div>
                  <span className="skill-percentage">{skill.level}%</span>
                </div>
                <div className="skill-bar">
                  <div
                    className="skill-progress"
                    style={{
                      width: `${skill.level}%`,
                      backgroundColor: skill.color,
                    }}
                  ></div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA Section */}
        <div className={`cta-section ${isVisible ? "fade-in-visible" : ""}`}>
          <h3 className="cta-title">Let's work together</h3>
          <p className="cta-description">
            I'm always open to new opportunities and collaborations. Let's
            discuss how we can bring your ideas to life!
          </p>
          <button
            className="cta-button"
            onClick={() =>
              document
                .getElementById("contact")
                .scrollIntoView({ behavior: "smooth" })
            }
          >
            Get In Touch
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z" />
            </svg>
          </button>
        </div>
      </div>
    </section>
  );
}
